var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.loading ? _c('div', [_c('loading')], 1) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("transfer_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('transfer_page.form_desc'))
    }
  }), _vm.getModuleConfig('transfer_page.content') ? _c('div', {
    staticClass: "page__content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('transfer_page.content'))
    }
  }) : _vm._e(), _c('form', {
    staticClass: "form"
  }, [_vm._l(_vm.fields, function (field, index) {
    return _c('div', {
      key: "field.".concat(index),
      staticClass: "field"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null
    }, [_vm._v(" " + _vm._s(field.title) + " ")]), field.type === 'select' ? _c('SharedSelect', {
      class: {
        invalid: _vm.v$.form[field.field_key].$error
      },
      attrs: {
        "options": _vm.sponsors,
        "placeholder": field.placeholder,
        "disabled": _vm.getModuleConfig('transfer_page.partner_data_source') != 'feversocial'
      },
      model: {
        value: _vm.form.sponsor_uuid,
        callback: function callback($$v) {
          _vm.$set(_vm.form, "sponsor_uuid", $$v);
        },
        expression: "form.sponsor_uuid"
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form.points,
        expression: "form.points"
      }],
      staticClass: "field__input",
      class: {
        invalid: _vm.v$.form[field.field_key].$error
      },
      attrs: {
        "type:": "number",
        "placeholder": field.placeholder,
        "disabled": field.disabled || _vm.getModuleConfig('transfer_page.partner_data_source') != 'feversocial'
      },
      domProps: {
        "value": _vm.form.points
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, "points", $event.target.value);
        }
      }
    }), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form[field.field_key].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" " + _vm._s(field.field_key == 'points' ? '輸入的資料有誤或未填寫且必須大於 0' : '輸入的資料有誤或未填寫，請確認') + " ")]) : _vm._e()], 1)]);
  }), _c('div', {
    staticClass: "page__button"
  }, [_c('SharedButton', {
    staticClass: "s-btn-outline-primary col-6",
    attrs: {
      "click": "cancel()"
    }
  }, [_vm._v(" 取消 ")]), _c('SharedButton', {
    staticClass: "s-btn-bg-primary col-6",
    attrs: {
      "disabled": _vm.loading || _vm.getModuleConfig('transfer_page.partner_data_source') != 'feversocial'
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 送出 ")])], 1)], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }